import { render, staticRenderFns } from "./ErrorExplanation.vue?vue&type=template&id=3b3211db&scoped=true&"
import script from "./ErrorExplanation.vue?vue&type=script&lang=js&"
export * from "./ErrorExplanation.vue?vue&type=script&lang=js&"
import style0 from "./ErrorExplanation.vue?vue&type=style&index=0&id=3b3211db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3211db",
  null
  
)

export default component.exports